import React, { useState } from "react";
import axios from "axios";
import toastr from "../../../utils/toast";

const UploadJDModal = ({ roleId, token, onClose, refresh }) => {
  const [file, setFile] = useState(null);
  const [uploading, setUploading] = useState(false);
  const [error, setError] = useState("");

  const handleFileChange = (e) => {
    setFile(e.target.files[0]);
    setError("");
  };

  const handleUpload = async () => {
    if (!file) {
      setError("Please select a file before uploading.");
      return;
    }

    const formData = new FormData();
    formData.append("jdFile", file);
    formData.append("role_id", roleId);

    try {
      setUploading(true);
      const response = await axios.post(
        `${process.env.REACT_APP_API_BASE_URL}/roles/upload_jd`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (response.status === 200) {
        toastr.success("JD Uploaded");
      } else {
        toastr.error("Something went wrong while uploading JD");
      }
      refresh?.(); // Optional chaining
      onClose();
    } catch (err) {
      console.error("Upload error:", err);
      setError("Upload failed. Please try again.");
    } finally {
      setUploading(false);
    }
  };

  const stopPropagation = (e) => e.stopPropagation();

  return (
    <>
      <div className="modal-backdrop fade show" />
      <div
        className="modal fade show d-block"
        tabIndex="-1"
        role="dialog"
        style={{ zIndex: 1056 }}
        onClick={onClose}
      >
        <div
          className="modal-dialog modal-dialog-centered"
          role="document"
          onClick={stopPropagation}
        >
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Upload JD File</h5>
              <button
                type="button"
                className="btn-close"
                aria-label="Close"
                onClick={onClose}
              />
            </div>
            <div className="modal-body">
              <div className="mb-3">
                <label htmlFor="jdFile" className="form-label">
                  Select a JD document
                </label>
                <input
                  type="file"
                  id="jdFile"
                  className="form-control"
                  accept=".pdf,.doc,.docx,.txt"
                  onChange={handleFileChange}
                />
                {error && <div className="text-danger mt-2 small">{error}</div>}
              </div>
              <button
                className="btn btn-primary w-100"
                onClick={handleUpload}
                disabled={uploading}
              >
                {uploading ? (
                  <>
                    <span
                      className="spinner-border spinner-border-sm me-2"
                      role="status"
                      aria-hidden="true"
                    ></span>
                    Uploading...
                  </>
                ) : (
                  "Upload"
                )}
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default UploadJDModal;
